export const  GET_TUTOR_REQUEST='tutorReducer/GET_TUTOR_REQUEST';
export const  GET_TUTOR_SUCCESS='tutorReducer/GET_TUTOR_SUCCESS';
export const  GET_TUTOR_FAILED='tutorReducer/GET_TUTOR_FAILED';